import React from 'react';
import { Link } from 'react-scroll';
import {
  IoCallOutline,
  IoMailOutline,
  IoLogoFacebook,
  IoLogoInstagram,
  IoLogoLinkedin,
  IoChevronForward
} from 'react-icons/io5';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main CTA Section */}
        <div className="footer-cta">
          <h2 className="footer-title">Let's get in touch!</h2>
          <p className="footer-description">
            Belageri Technologies is dedicated to providing cutting-edge technology solutions
            that drive innovation and growth for businesses across India and beyond.
          </p>
          <Link
            to="contact"
            smooth={true}
            duration={500}
            offset={-70}
            className="contact-button"
          >
            Contact us <IoChevronForward className="btn-arrow" />
          </Link>
        </div>

        {/* Navigation Links */}
        <div className="footer-nav">
          <Link to="about" smooth duration={500} offset={-70} className="footer-nav-link">
            <IoChevronForward className="nav-arrow" /> About Us
          </Link>
          <Link to="workwithus" smooth duration={500} offset={-70} className="footer-nav-link">
            <IoChevronForward className="nav-arrow" /> Work With Us
          </Link>
          <Link to="services" smooth duration={500} offset={-70} className="footer-nav-link">
            <IoChevronForward className="nav-arrow" /> Services
          </Link>
          <Link to="testimonials" smooth duration={500} offset={-70} className="footer-nav-link">
            <IoChevronForward className="nav-arrow" /> Testimonials
          </Link>
          <Link to="contact" smooth duration={500} offset={-70} className="footer-nav-link">
            <IoChevronForward className="nav-arrow" /> Contact Us
          </Link>
        </div>

        {/* Footer Info Section */}
        <div className="footer-info">
          {/* Headquarters */}
          <div className="footer-section">
            <h3 className="footer-section-title">Headquarters</h3>
            <div className="footer-address">
              <p>Belageri Technologies Pvt Ltd</p>
              <p>NO-11-1400/136/7,</p>
              <p>Akkamahadevi Colony, KHB, Opp. High Court,</p>
              <p>Kalaburgi, Karnataka - 585103</p>
              <p>India</p>
            </div>
          </div>

          {/* Contact Info with animated icons */}
          <div className="footer-section">
            <h3 className="footer-section-title">Contact</h3>
            <div className="footer-contact">
              <a href="tel:+919449974910" className="contact-line">
                <span className="icon-badge ring">
                  <IoCallOutline />
                  <span className="ping" aria-hidden="true" />
                </span>
                <span>+91 9449974910</span>
              </a>
              <a href="mailto:contactus@belageri.com" className="contact-line">
                <span className="icon-badge pulse">
                  <IoMailOutline />
                </span>
                <span>contactus@belageri.com</span>
              </a>
            </div>
          </div>

          {/* Location Map */}
          <div className="footer-section">
            <h3 className="footer-section-title">Our Location</h3>
            <div className="footer-map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3809.1248220713774!2d76.80069597378785!3d17.309525605046243!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc8c7cde0c966fd%3A0xa91649fafc3a71fb!2sBelageri%20Technologies%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1758178467264!5m2!1sen!2sin"
                width="250"
                height="150"
                style={{ border: 0, borderRadius: '8px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Belageri Technologies Location"
              ></iframe>
            </div>
          </div>

          {/* Social Media with animated icons */}
          <div className="footer-section">
            <h3 className="footer-section-title">Follow us</h3>
            <div className="footer-social">
              {/* <a href="#" className="social-link">
                <span className="icon-badge hover-pop fb">
                  <IoLogoFacebook />
                </span>
                <span>Facebook</span>
              </a>
              <a href="#" className="social-link">
                <span className="icon-badge hover-pop ig">
                  <IoLogoInstagram />
                </span>
                <span>Instagram</span>
              </a> */}
              <a href="https://www.linkedin.com/company/belageri-technologies-private-limited/posts/?feedView=all" className="social-link">
                <span className="icon-badge hover-pop li">
                  <IoLogoLinkedin />
                </span>
                <span>LinkedIn</span>
              </a>
              {/* Example YouTube as plain text arrow can be kept or replaced later */}
            </div>
          </div>

          {/* Company Description */}
          {/* <div className="footer-section footer-description-section">
            <p className="company-description">
              We are a technology service company that, with our thinkers and doers,
              enable breakthroughs that help industrial businesses change.
            </p>
          </div> */}
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p>© Belageri Technologies 2025</p>
          {/* <div className="footer-bottom-links">
            <a href="#" className="footer-bottom-link">Privacy statement</a>
            <a href="#" className="footer-bottom-link">Privacy inquiry</a>
            <a href="#" className="footer-bottom-link">Accessibility</a>
            <a href="#" className="footer-bottom-link">Terms of service</a>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
